<template>
  <div
    v-if="visible"
    class="room-plan-modal-overlay"
    @click.self="$emit('close')"
  >
    <div class="room-plan-modal-card">
      <button
        type="button"
        class="room-plan-modal-close"
        aria-label="Fermer"
        @click="$emit('close')"
      >
        ×
      </button>
      <p class="merriweather-reg-24 mb-2">Configurer vos chambres</p>
      <p class="raleway-reg-p15 room-plan-modal-copy">
        Indiquez le nombre de voyageurs par chambre
      </p>

      <div class="room-plan-modal-summary">
        <span class="raleway-semi-p13">Total</span>
        <span class="raleway-reg-p13">
          {{ totals.adults }} adulte{{ totals.adults > 1 ? 's' : '' }}
          • {{ totals.children }} enfant{{ totals.children > 1 ? 's' : '' }}
        </span>
      </div>

      <div
        v-for="(plan, index) in roomPlans"
        :key="`room-plan-${index}`"
        class="room-plan-card"
      >
        <div class="d-flex justify-content-between align-items-center mb-3">
          <p class="raleway-semi-p15 mb-0">Chambre {{ index + 1 }}</p>
          <button
            v-if="roomPlans.length > 1"
            type="button"
            class="room-plan-link-button"
            @click="$emit('remove-room', index)"
          >
            Supprimer
          </button>
        </div>

        <div class="room-plan-grid">
          <label class="room-plan-field">
            <span class="raleway-semi-p13">Adultes</span>
            <input
              :value="plan.adults"
              type="number"
              min="1"
              @input="$emit('update-room-value', { index, field: 'adults', value: $event.target.value })"
            />
          </label>

          <label class="room-plan-field">
            <span class="raleway-semi-p13">Enfants</span>
            <input
              :value="plan.children"
              type="number"
              min="0"
              @input="$emit('update-room-children', { index, value: $event.target.value })"
            />
          </label>
        </div>

        <div v-if="Number(plan.children) > 0" class="mt-3">
          <span class="raleway-semi-p13 d-block mb-2">Âge des enfants</span>
          <div class="room-plan-ages">
            <label
              v-for="childIndex in Number(plan.children)"
              :key="`room-plan-${index}-child-${childIndex}`"
              class="room-plan-age-field"
            >
              <span class="raleway-reg-p12">Enfant {{ childIndex }}</span>
              <input
                :value="plan.children_ages[childIndex - 1] || ''"
                type="number"
                min="0"
                max="17"
                placeholder="Âge"
                @input="$emit('update-room-child-age', { index, childIndex: childIndex - 1, value: $event.target.value })"
              />
            </label>
          </div>
        </div>
      </div>

      <p v-if="error" class="room-plan-error raleway-reg-p13 mb-0">
        {{ error }}
      </p>

      <div class="room-plan-actions">
        <button type="button" class="room-plan-link-button" @click="$emit('add-room')">
          Ajouter une chambre
        </button>
        <button type="button" class="hortense-btn-primary" @click="$emit('save')">
          Valider
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoomPlanModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    roomPlans: {
      type: Array,
      default: () => [],
    },
    totals: {
      type: Object,
      default: () => ({ adults: 0, children: 0 }),
    },
    error: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped lang="scss">
.room-plan-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(22, 31, 27, 0.55);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.room-plan-modal-card {
  position: relative;
  width: min(760px, 100%);
  max-height: 85vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 18px;
  padding: 28px;
}

.room-plan-modal-close {
  position: absolute;
  top: 14px;
  right: 16px;
  border: 0;
  background: transparent;
  font-size: 28px;
  line-height: 1;
  color: #2c5e4b;
  cursor: pointer;
}

.room-plan-modal-copy {
  color: #4f5b55;
}

.room-plan-modal-summary {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  background: #f4f8f6;
  margin: 18px 0;
}

.room-plan-card {
  border: 1px solid #d9e7df;
  border-radius: 14px;
  padding: 18px;
  margin-bottom: 16px;
}

.room-plan-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.room-plan-field,
.room-plan-age-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.room-plan-field input,
.room-plan-age-field input {
  width: 100%;
  min-height: 52px;
  padding: 2px 16px;
  border: 1px solid #cddfd3;
  border-radius: 10px;
  background: #fff;
}

.room-plan-field input:focus,
.room-plan-age-field input:focus {
  outline: none;
  border-color: #3b6152;
}

.room-plan-ages {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.room-plan-link-button {
  border: 0;
  background: transparent;
  color: #2c5e4b;
  text-decoration: underline;
  padding: 0;
}

.room-plan-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}

.room-plan-error {
  color: #d56a70;
}

@media (max-width: 768px) {
  .room-plan-modal-overlay {
    padding: 0;
    align-items: flex-end;
  }

  .room-plan-modal-card {
    width: 100%;
    max-height: 90vh;
    border-radius: 16px 16px 0 0;
    padding: 22px 16px 16px;
  }

  .room-plan-modal-close {
    top: 12px;
    right: 14px;
  }

  .room-plan-modal-card > .merriweather-reg-24 {
    max-width: calc(100% - 34px);
    font-size: 20px;
    line-height: 1.3;
  }

  .room-plan-modal-copy {
    font-size: 13px;
    line-height: 1.5;
  }

  .room-plan-modal-summary {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    padding: 12px 14px;
    margin: 14px 0;
  }

  .room-plan-card {
    border-radius: 12px;
    padding: 14px;
    margin-bottom: 12px;
  }

  .room-plan-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .room-plan-ages {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }

  .room-plan-field input,
  .room-plan-age-field input {
    min-height: 46px;
    padding: 2px 12px;
    border-radius: 8px;
  }

  .room-plan-actions {
    position: sticky;
    bottom: -16px;
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 14px;
    margin: 16px -16px -16px;
    padding: 14px 16px 16px;
    background: #fff;
    border-top: 1px solid #edf3ef;
  }

  .room-plan-actions .hortense-btn-primary {
    width: 100%;
  }

  .room-plan-actions .room-plan-link-button {
    align-self: center;
  }
}
</style>
